<template>
  <div class="etms-router-body">
    <div class="etms-router-search">
      <span class="etms-router-search-label fl">账单名称：</span>
      <el-input size="mini" v-model="search.BillTitle" placeholder="填写账单名称搜索" class="etms-router-search-element fl"></el-input>
      <span class="etms-router-search-label fl">账单批次：</span>
      <el-input size="mini" v-model="search.BillBatchs" placeholder="填写账单批次搜索" class="etms-router-search-element fl"></el-input>
      <span class="etms-router-search-label fl">账单分类：</span>
      <el-select size="mini" v-model="search.BillType" placeholder="选择账单分类搜索" class="etms-router-search-element el-width-130 fl" filterable clearable>
        <el-option v-for="item in customerbilltypes" :label="item.label" :value="item.value" :key="item.value"></el-option>
      </el-select>
      <span class="etms-router-search-label fl">账单日期：</span>
      <el-date-picker size="mini" v-model="search.timeslot" type="datetimerange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" class="etms-router-search-element el-width-300 fl">
      </el-date-picker>
      <el-button size="mini" type="primary" icon="el-icon-search" class="etms-router-search-button fr">搜索</el-button>
      <div class="clear"></div>
    </div>
    <div class="div-list">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageindex" :page-sizes="pagesizes" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="recordcount"></el-pagination>
      <el-table :data="bills" :border="true" class="etms-router-list">
        <el-table-column type="index" label="序号" header-align="center" align="center">
        </el-table-column>
        <el-table-column label="账单日期" align="center" prop="BillDate"></el-table-column>
        <el-table-column label="账单类型" align="center" prop="BillType"></el-table-column>
        <el-table-column label="账单名称" align="center" prop="BillTitle"></el-table-column>
        <el-table-column label="账单批次" align="center" prop="BillBatchs"></el-table-column>
        <el-table-column label="账单总额" align="center" prop="BillAmount"></el-table-column>
        <el-table-column label="账单备注" align="center" prop="BillNote"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="下载账单" placement="top">
              <el-button size="mini" type="primary" @click="handleDownload(scope.$index,scope.row)" icon="el-icon-download" circle></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      customerbilltypes: this.constant.customerbilltypes,
      pagesizes: this.constant.pagesizes,
      pageindex: 1,
      pagesize: 100,
      recordcount: 0,
      pickerOptions: this.constant.pickerOptions,
      search: {
        BillTitle: '',
        BillBatchs: '',
        BillType: '',
        timeslot: []
      },
      bills: [
        {
          BillId: '',
          BillType: '核算账单',
          BillAmount: '5806.343',
          BillBatchs: 'ksm-20181201-1',
          BillTitle: '康美森18年12月1日账单-1',
          BillDate: '2018-12-01',
          BillNote: '账单已出,请注意查收',
          BillingStandard: ''
        }
      ]
    }
  },
  methods: {
    handleSizeChange (val) { },
    handleCurrentChange (val) { },
    handleDownload (index, row) {
    },
  }
}
</script>

<style scoped>
@import "../../../css/etms/home.css";
@import "../../../css/iconfont.css";

.etms-router-search-button {
  margin: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/etms/ctms/logistics_bills.vue